'use strict';

class MeMap {

	constructor() {
		window.addEventListener('load', this.initMap.bind(this), false);
	}

	initMap() {
		const latlng = new google.maps.LatLng(35.661452, 139.732462);
		const options = {
			center: latlng,
			zoom: 17
		};
		this.map = new google.maps.Map(document.getElementById('map-canvas'), options);
		const infoWindow = new google.maps.InfoWindow({
			position: latlng,
			content: `
				<img src="/wp-content/themes/me-corporate/assets/images/logo-horizontal.png" width="240" style="margin: .5rem 0"><br>
				<span>東京都港区六本木6丁目8番10号<br>STEP六本木4F</span>
			`,
		});
		infoWindow.open(this.map);
		// const markerOptions = {
		// 	position: latlng,
		// 	map: this.map,
		// 	// icon: icon,
		// 	title: '株式会社モブキャスト・フィナンシャル'
		// };
		// const marker = new google.maps.Marker(markerOptions);
	}
}

new MeMap();



// WEBPACK FOOTER //
// ./assets/src/scripts/map.js